import React, { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { toast } from 'react-toastify'
import { withTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import * as validations from './validation'
import { apiRequest } from 'store/Misc/apiRequest'
import { setFormLoading } from 'store/slices/miscSlice'
import LoginForm from './forms/LoginForm'
import { destructureErrorMessage } from 'Helper'
import RegistrationForm from './forms'
import ForgotPassword from './forms/ForgotPassword'
import { withRouter } from 'hooks/withRouter'
import AuthLayout from './components/AuthLayout'
import EmailVerification from './components/EmailVerification'

const validationFields = [
  'BusinessRegisteratinValidation',
  'ContactPersonValidation',
  'PasswordValidation'
]


export default withTranslation()(withRouter(function Registration({ t, router: { navigate } }) {

  const [step, setstep] = useState(0)
  const [loginError, setLoginError] = useState(null)
  const [forgotSent, setForgotSent] = useState(false)
  const [forgotEmail, setForgotEmail] = useState('')
  const [verifying, setVerifying] = useState(false)
  const [verifyEmail, setVerifyEmail] = useState('')
  const dispatch = useDispatch()
  const pathname = window.location.pathname

  const getResolver = () => {
    if (pathname === '/register') return yupResolver(validations[validationFields[step]])
    if (pathname === '/login') return yupResolver(validations.LoginValidation)
    return yupResolver(validations.EmailValidation)
  }

  const method = useForm({
    mode: 'all',
    resolver: getResolver()
  })

  const { handleSubmit, formState: { isValid, isDirty } } = method


  const submit = async (payload) => {
    const { name, primary_phone, primary_email, country_id, category_id } = payload
    const { first_name, last_name, phone, email, password, password_confirmation } = payload

    setLoginError(null)
    dispatch(setFormLoading())

    try {
      let data = await apiRequest({
        method: 'post',
        url: pathname === '/register' ? 'merchants/setup' : 'auth/login',
        payload: pathname === '/register' ? {
          merchant: { name, primary_phone, primary_email, country_id, category_id },
          user: { first_name, last_name, phone, email, password, password_confirmation }
        } : payload,
        // action: pathname === '/register' ? null : auth
      })

      if (data) {
        if (pathname === '/login') {
          localStorage.setItem('__ra_pos', data.data.access_token)
          localStorage.setItem('__ra_pos_refresh', data.data.refresh_token)
          localStorage.setItem('merchant_id', data.data.user.id)

          if (data.data.access_token && data.data.refresh_token) navigate('/dashboard')
        }
        else if (pathname === '/register') {
          setVerifyEmail(primary_email)
          setVerifying(true)
        }
        else if (pathname === '/forgot-password') {
          setForgotEmail(payload.email)
          setForgotSent(true)
        }
      }
    } catch ({ message }) {
      if (pathname === '/login') {
        setLoginError(t('registration.login.error'))
      } else if (pathname === '/forgot-password') {
        // Show the confirmation regardless of outcome so this never reveals
        // whether an email address has a merchant account.
        setForgotEmail(payload.email)
        setForgotSent(true)
      } else {
        destructureErrorMessage(message).map(msg => {
          return toast.error(t(msg), { autoClose: 15000 })
        })
      }
    }
    dispatch(setFormLoading('close'))
    return
  }


  const pageSwitcher = (name) => {
    switch (name) {
      case '/login':
        return <LoginForm yupFields={{ isDirty, isValid }} loginError={loginError} />

      case '/register':
        return verifying ? (
          <EmailVerification
            email={verifyEmail}
            onConfirm={() => { toast.success(t('registration.success')); navigate('/login') }}
          />
        ) : (
          <RegistrationForm yupFields={{ isDirty, isValid }} steps={{ step, setstep }} validationFields={validationFields} />
        )

      case '/forgot-password':
        return <ForgotPassword yupFields={{ isDirty, isValid }} sent={forgotSent} email={forgotEmail} />

      default:
        return
    }
  }


  return (
    <AuthLayout>
      <FormProvider {...method}>
        <form onSubmit={handleSubmit(submit)}>
          {
            pageSwitcher(pathname)
          }
        </form>
      </FormProvider>
    </AuthLayout>
  )
}))





// const pageSwitcher = (name) => {

//   switch (name) {
//     case '':
//       return <StepOne />

//     case '/register':
//       return <StepTwo />

//     case '/forgot-password':
//       return <StepThree />

//     default:
//       return
//   }
// }